<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <div mat-dialog-title class="tw-text-center tw-font-bold">
    Macnica Tracks API Key 発行完了
  </div>
  <mat-dialog-content class="!tw-pt-2 tw-w-[90%] !tw-mx-auto">
    <div class="tw-flex tw-gap-x-4">
      <div class="tw-flex tw-flex-col tw-gap-y-6 tw-w-full">
        <!-- メッセージ -->
        <div class="tw-min-w-[292px]">
          <div class="tw-mb-2">
            Macnica Tracks API を利用するための Client ID と Client
            Secretを発行しました。<br />
            本ポップアップを閉じると設定値は確認できなくなるため、下記設定値はコピーして大切に保管ください。
          </div>
        </div>

        <table class="tw-table-auto tw-border-0">
          <tr>
            <td class="tw-font-bold tw-w-28">Client ID</td>
            <td class="tw-align-middle">
              <div class="tw-flex tw-items-center">
                <div class="tw-align-middle">{{ apikey.clientId }}</div>
                <button mat-icon-button (click)="copyClientId()">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </td>
          </tr>

          <tr>
            <td class="tw-font-bold tw-w-28">Client Secret</td>
            <td class="tw-align-middle">
              <div class="tw-flex tw-items-center">
                <div class="tw-align-middle">{{ apikey.clientSecretValue }}</div>
                <button mat-icon-button (click)="copyClientSecret()">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
    <button
      id="cancel-btn"
      mat-raised-button
      class="tw-w-60"
      type="button"
      color="warn"
      (click)="closeDialog()"
    >
      <mat-icon>close</mat-icon>
      <span>確認したので閉じる</span>
    </button>
  </mat-dialog-actions>
</div>
